import { render } from "./TokenForm.vue?vue&type=template&id=34bacdd2&scoped=true"
import script from "./TokenForm.vue?vue&type=script&lang=js"
export * from "./TokenForm.vue?vue&type=script&lang=js"

import "./TokenForm.vue?vue&type=style&index=0&id=34bacdd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bacdd2"]])

export default __exports__